/**
 * Validates an email address format using a standard regex pattern
 * @param {string} emailAddress - The email address to validate
 * @param {boolean} allowEmpty - Whether to allow empty email addresses (defaults to true)
 * @returns {boolean} - True if email format is valid or (empty and allowEmpty=true), false otherwise
 */
export const validateEmailAddress = (emailAddress, allowEmpty = true) => {
  if (!emailAddress) {
    return allowEmpty;
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(emailAddress);
};
